import { makeAutoObservable } from 'mobx';
import { IAnyToAnyExchangesSetting } from '../models/User';
import { IChangeable } from './types';

interface IAnyToAnyExchangesSettingChanges extends Partial<IAnyToAnyExchangesSetting> {
};

class AnyToAnyExchangesStore implements IChangeable<IAnyToAnyExchangesSettingChanges>{
    private _model!: IAnyToAnyExchangesSetting;
    private _changes: IAnyToAnyExchangesSettingChanges = {};

    constructor(anyToAnyExchangesSetting: IAnyToAnyExchangesSetting) {
        makeAutoObservable(this, {}, { autoBind: true });
        this.setModel(anyToAnyExchangesSetting);
    }

    private setModel(model: IAnyToAnyExchangesSetting) {
        this._model = model;
        this.discardChanges();
    }

    public hasChanges() {
        return !!Object.keys(this._changes).length;
    }

    public getUpdatedModel(): IAnyToAnyExchangesSetting {
        return { ...this._model, ...this._changes };
    }

    public discardChanges(): void {
        this._changes = {};
    }

    public get enableShopNow(): boolean {
        return this._changes.enable_shop_now ?? this._model?.enable_shop_now ?? false;
    }

    public setEnableShopNow(value: boolean) {
        this._changes.enable_shop_now = value;
        this._clearUnneededChanges();
    }

    private _clearUnneededChanges() {
        Object.keys(this._changes).forEach(key => {
            const theKey = key as keyof IAnyToAnyExchangesSettingChanges;
            if (this._changes[theKey] === this._model?.[theKey]) {
                delete this._changes[theKey];
            }
        });
    }
}

export default AnyToAnyExchangesStore;
